import React from 'react';
import NavBar from '../nav/NavBar.tsx';
import './Privacy.css';

function HomePage() {
  return (
    <>
      <NavBar></NavBar>
      <div className={'overlay'}>
      <div className={'viewport'}>
        Privacy Policy
<br></br><br></br>
Effective Date: August 4, 2025
<br></br>
<br></br>
Thank you for using our mobile applications ("Apps"). We respect your privacy and are committed to being transparent about how our Apps handle information.<br></br>
This Privacy Policy explains what information is collected when you use our Apps available on the Apple App Store.<br></br>
<br></br>
Who We Are<br></br>
These Apps are developed and published by:<br></br>
The DezLab LLC<br></br>
<br></br>
If you have any questions about this Privacy Policy, you can contact us at:<br></br>
Email: [support@thedezlab.com]<br></br>
<br></br>
Information We Collect<br></br>
Information Collected by Us<br></br>
We do not collect, store, transmit, or sell any personal information.
<br></br>
Our Apps do not require you to:
<br></br>
* Create an account
<br></br>
* Sign in
<br></br>
* Register
<br></br>
* Provide your name
<br></br>
* Provide your email address
<br></br>
* Provide your phone number
<br></br>
<br></br>
We also do not collect or store:
<br></br>
* Contacts
<br></br>
* Photos
<br></br>
* Videos
<br></br>
* Messages
<br></br>
* Files
<br></br>
* Precise location
<br></br>
* Health information
<br></br>
* Financial information
<br></br>
* User-generated content
<br></br>
* Browsing history
<br></br>
* Search history
<br></br>
<br></br>
We do not create user profiles or maintain databases containing personal information.<br></br>
<br></br>
Advertising:<br></br>
Our Apps display advertisements using Google Mobile Ads (AdMob).<br></br>
Although we do not collect personal information ourselves, Google may automatically process certain information through the AdMob SDK to provide and operate advertising services.<br></br>
This processing is performed by Google under its own privacy practices and may include information such as device identifiers, IP address, device information, approximate location derived from IP address, diagnostics, and advertising performance data.<br></br>
We do not control the information Google collects through AdMob, nor do we receive personal information collected by Google for its advertising services.<br></br>
<br></br>
Tracking:<br></br>
Our Apps do not perform tracking or analytics for our own purposes.<br></br>
We do not request App Tracking Transparency (ATT) permission and do not track your activity across other companies' apps or websites ourselves.<br></br>
Any information processed by Google through AdMob is governed by Google's own privacy practices and applicable law.<br></br>
<br></br>

Analytics:<br></br>
We do not use analytics services to monitor or analyze how users interact with our Apps.<br></br>
<br></br>
Data Sharing:<br></br>
Because we do not collect personal information, we do not sell, rent, or share your personal information.<br></br>
Any information processed by Google through AdMob is handled according to Google's own privacy practices.<br></br>
<br></br>
Children's Privacy:<br></br>
Our Apps are suitable for users of all ages.<br></br>
We do not knowingly collect personal information from children or any other users.<br></br>
Our Apps do not require registration or collect personal information directly. Advertisements are provided through Google Mobile Ads (AdMob), and any information processed by Google is governed by Google's own privacy practices and applicable law.<br></br>
Parents or guardians who have questions regarding Google's advertising practices should refer to Google's privacy documentation.<br></br>
<br></br>
Data Retention:<br></br>
Because we do not collect or store personal information, we do not retain personal information.<br></br>
Information processed by Google through AdMob is retained according to Google's own policies.<br></br>
<br></br>
Security:<br></br>
Since we do not collect personal information, we do not maintain databases containing users' personal information.<br></br>
We nevertheless use reasonable development practices intended to help protect the integrity of our Apps.<br></br>
<br></br>
International Users:<br></br>
Our Apps may be downloaded and used worldwide.<br></br>
Third-party providers such as Google may process information in countries outside your own in accordance with their own privacy policies and applicable law.<br></br>
<br></br>
Changes to This Privacy Policy:<br></br>
We may update this Privacy Policy from time to time.<br></br>
If changes are made, the Effective Date at the top of this page will be updated.<br></br>
Your continued use of the Apps after any changes become effective constitutes acceptance of the revised Privacy Policy.<br></br>
<br></br>
Contact Us:<br></br>
If you have any questions about this Privacy Policy, please contact:<br></br>
The DezLab LLC<br></br>
Email: [support@thedezlab.com]
<br></br>
      </div>
      </div>
    </>
  );
}

export default HomePage;
